export default {
  container: {
    height: '100%'
  },
  paymentsContainer: {
    height: '100%'
  },
  paymentDocumentModal: {
    padding: '20px 20px 0'
  }
};
